
import Button from '../../../components/base/Button';

export default function CTASection() {
  const handleScheduleAppointment = () => {
    // Déclencher l'ouverture du modal de devis du Header
    const event = new CustomEvent('openQuoteModal');
    window.dispatchEvent(event);
  };

  return (
    <section className="py-20 bg-gradient-to-br from-red-600 to-red-800 relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Prêt à Sécuriser Votre <span className="text-red-200">Entreprise</span> ?
          </h2>
          <p className="text-xl text-red-100 mb-12 max-w-3xl mx-auto leading-relaxed">
            Rejoignez plus de 500 entreprises qui nous font confiance pour leur sécurité. 
            Obtenez votre devis personnalisé en moins de 24h.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <a 
              href="tel:+21620403150"
              className="whitespace-nowrap cursor-pointer font-semibold rounded-lg transition-all duration-200 flex items-center justify-center bg-white text-red-600 hover:bg-red-50 px-8 py-4 text-lg"
            >
              <i className="ri-phone-line mr-2"></i>
              Appeler Maintenant
            </a>
            <button 
              onClick={handleScheduleAppointment}
              className="whitespace-nowrap cursor-pointer font-semibold rounded-lg transition-all duration-200 flex items-center justify-center border-2 border-white text-white hover:bg-white hover:text-red-600 px-8 py-4 text-lg"
            >
              <i className="ri-calendar-line mr-2"></i>
              Planifier un RDV
            </button>
          </div>
        </div>
      </div>

      {/* Trust Indicators (preserved from original) */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-white mt-12 px-4">
        <div className="flex items-center justify-center space-x-3">
          <i className="ri-shield-check-line text-red-400 text-2xl"></i>
          <div>
            <div className="font-bold">Certifié</div>
            <div className="text-sm text-gray-300">Normes CE</div>
          </div>
        </div>
        <div className="flex items-center justify-center space-x-3">
          <i className="ri-customer-service-line text-red-400 text-2xl"></i>
          <div>
            <div className="font-bold">Support 24/7</div>
            <div className="text-sm text-gray-300">Assistance continue</div>
          </div>
        </div>
        <div className="flex items-center justify-center space-x-3">
          <i className="ri-award-line text-red-400 text-2xl"></i>
          <div>
            <div className="font-bold">25 Ans</div>
            <div className="text-sm text-gray-300">D'expérience</div>
          </div>
        </div>
      </div>
    </section>
  );
}
